// Safari and some third-party scripts/extensions reject promises with a synthetic
// DOM Event (typically an untrusted `unhandledrejection`-typed event) instead of an
// Error. Sentry's global onunhandledrejection handler then captures a stack-less
// "Event `CustomEvent` (type=unhandledrejection) captured as promise rejection" with
// no actionable first-party frames. Drop those. Genuine errors are Error instances
// (carrying a stacktrace) and pass through untouched.
export const isNonErrorEventRejection = (value) => {
  if (!value || typeof value !== "object") return false;
  if (value instanceof Error) return false;
  if (typeof Event !== "undefined" && value instanceof Event) return true;
  // Fall back to duck-typing when Event isn't a usable global (older Safari, workers).
  return typeof value.type === "string" && "isTrusted" in value && "target" in value;
};

export const beforeSend = (event, hint) => {
  if (isNonErrorEventRejection(hint?.originalException)) return null;
  return event;
};
